import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=3e9a89e2&"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts&"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=3e9a89e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports